<template>
  <v-container>
    <v-row><h1>Profile</h1></v-row>
    <v-row><p class="error" v-if="error">{{ error }}</p></v-row>
    <v-row>
      <v-snackbar v-model="updated" timeout=6000>
        Settings updated
        <template v-slot:action="{ attrs }">
          <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="updated = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-row>

    <div>
      <img :src="$auth.user.picture">
      <h2>Name: {{ $auth.user.name }}</h2>
      <p>Email: {{ $auth.user.email }}</p>
      <p>ID: {{ userId }}</p>
    </div>

    <v-divider></v-divider>

    <div>
      <pre>{{ JSON.stringify($auth.user, null, 2) }}</pre>
    </div>

  </v-container>
</template>

<script>

export default {
  name: 'Profile',
  data() {
    return {
      error: '',
      updated: false,
      userId: this.$auth.user.sub.split('|')[1],
    };
  },
  async created() {
    // UserService.getUser(this.accountId)
    //   .then((user) => { this.user = user; })
    //   .catch(this.reportError);
  },
  methods: {
    reportError(err) {
      this.error = err.message;
    },
  },
};
</script>

<style scoped>
div.container {
  /* max-width: 800px; */
  padding: 10px;
  margin: 0 auto;
}

p.error {
  border: 1px solid #ff5b5f;
  background-color: #ffc5c1;
  padding: 10px;
  margin-bottom: 15px;
}

</style>
